import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { RiGlobalLine } from 'react-icons/ri';
import './Footer.css';

const Footer = () => {
  const [userInfo, setUserInfo] = useState({
    ip: 'Loading...'
  });

  useEffect(() => {
    // Fetch user IP and country information using public APIs (no key required)
    const fetchUserInfo = async () => {
      try {
        // Primary: Using ip-api.com free public API (HTTPS)
        const response = await fetch('https://ip-api.com/json/?fields=status,message,country,countryCode,query');
        const data = await response.json();
        
        if (data.status === 'success' && data.query) {
          setUserInfo({
            ip: data.query
          });
          return;
        }
      } catch (error) {
        console.log('Primary API failed, trying alternatives...', error);
      }

      // Fallback 1: Using ipapi.co (free tier, no key needed for basic info)
      try {
        const response2 = await fetch('https://ipapi.co/json/');
        const data2 = await response2.json();
        
        if (data2.ip) {
          setUserInfo({
            ip: data2.ip
          });
          return;
        }
      } catch (error) {
        console.log('Fallback API 1 failed, trying final option...', error);
      }

      // Fallback 2: Using ipify.org (just IP, no country)
      try {
        const response3 = await fetch('https://api.ipify.org?format=json');
        const data3 = await response3.json();
        if (data3.ip) {
          setUserInfo({
            ip: data3.ip
          });
          return;
        }
      } catch (error) {
        console.log('All APIs failed', error);
      }

      // Final fallback
      setUserInfo({
        ip: 'Not available'
      });
    };

    fetchUserInfo();
  }, []);


  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-left">
            <p className="footer-copyright">
              Copyright © {currentYear} Bangladesh Telecommunication Regulatory Commission (BTRC)
            </p>
            <div className="footer-user-info">
              <RiGlobalLine className="info-icon" />
              <span className="user-ip">IP: {userInfo.ip}</span>
            </div>
          </div>
          <div className="footer-links">
            <Link to="/terms">Terms of Service</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/contact">Contact Us</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

